import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupHasData',
})
export class GroupHasDataPipe implements PipeTransform {
  transform(value: any, property: string, list: any[] = []): boolean {
    if (!property || value == null) {
      return false;
    }

    return !!list?.find((x) => x[property] === value);
  }
}
